import {
  startCreator,
  serviceIntroduction,
  helpCenter,
  termsOfUse,
  privacyPolicy,
  communityPolicy,
  operatingHours,
  contactUs,
  kakaotalk,
  twitter,
  instagram,
  notice,
  creatorGuide,
} from '@libraries/common/sitemap';
import KakaoSolid from '@assets/svgs/KakaoSolid.svg';
import TwitterSolid from '@assets/svgs/TwitterSolid.svg';
import InstagramSolid from '@assets/svgs/InstagramSolid.svg';

export const menus = {
  startCreator: {
    link: startCreator,
    name: '크리에이터 시작',
  },
  serviceIntroduction: {
    link: serviceIntroduction,
    name: '서비스 소개',
  },
  notice: {
    link: notice,
    name: '공지사항',
  },
  helpCenter: {
    link: helpCenter,
    name: '헬프센터',
  },
  creatorGuide: {
    link: creatorGuide,
    name: '크리에이터 가이드',
  },
  termsOfUse: {
    link: termsOfUse,
    name: '이용약관',
  },
  privacyPolicy: {
    link: privacyPolicy,
    name: '개인정보 처리방침',
  },
  communityPolicy: {
    link: communityPolicy,
    name: '커뮤니티 운영방침',
  },
  operatingHours: {
    name: operatingHours,
  },
  contactUs: {
    name: '스테디오에 문의',
    link: contactUs,
  },
  kakaotalk: {
    icon: KakaoSolid,
    link: kakaotalk,
  },
  twitter: {
    icon: TwitterSolid,
    link: twitter,
  },
  instagram: {
    icon: InstagramSolid,
    link: instagram,
  },
};
